import ProjectAsset from '../models/ProjectAsset'

export function findTimelinePlacement(timelineItems, asset, { matchByProjectAssetId = false } = {}) {
  if (!timelineItems) return null

  for (const items of timelineItems.values()) {
    const found = items.find((item) => {
      if (matchByProjectAssetId) {
        return String(item.project_asset_id) === String(asset.id)
      }
      return String(item.id) === String(asset.id)
    })
    if (found) return found
  }

  return null
}

export function resolveTimelineAssetNote(asset, timelinePlacement) {
  const raw = timelinePlacement?.notes ?? asset?.notes ?? ''
  return typeof raw === 'string' ? raw : ''
}

export function resolveAdvertiserSidebarNote(asset, campaignScenario) {
  if (!asset) return ''

  if (asset instanceof ProjectAsset) {
    const placement = campaignScenario?.campaign_scenarios_project_assets?.find(
      (c) => +c.project_asset_id === +asset.id,
    )
    return resolveTimelineAssetNote(asset, placement).trim()
  }

  return resolveTimelineAssetNote(asset, null).trim()
}
